import { render, staticRenderFns } from "./SingleVideoFileUpload.vue?vue&type=template&id=6349b38c&scoped=true"
import script from "./SingleVideoFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleVideoFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SingleVideoFileUpload.vue?vue&type=style&index=0&id=6349b38c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349b38c",
  null
  
)

export default component.exports